import React from "react";
import "./OwlBotWord.css";

interface owlBotWordProps {
  word: string;
  onClick: () => void;
}

const OwlBotWord = (props: owlBotWordProps) => {
  const [isHovered, setIsHovered] = React.useState(false);
  return (
    <span
      className={isHovered ? "hovered" : "normal"}
      onClick={props.onClick}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      {props.word}
    </span>
  );
};

export default OwlBotWord;
